import { loadProxyUrl } from "./axiosConfig";

export const sportsDataApiBaseUrl = `${loadProxyUrl()}/api`;